export const VITE_REOWN_PROJECT_ID = import.meta.env.VITE_REOWN_PROJECT_ID || "b56e18d47c72ab683b10814fe9495694";
export const VITE_DEFAULT_AUTHENTICATED_VIEW = import.meta.env.VITE_DEFAULT_AUTHENTICATED_VIEW || "/visualizer";
export const VITE_ADMIN_WALLET = import.meta.env.VITE_ADMIN_WALLET || "6Qxu5cRDNFEZvYtgtvo27tdg7LuT5wuX7THqqPbBWJmT";
